/*
  https://tag-ur-it.net/ — Quantity Pricing Logic
  File: assets/quantity-pricing.js
*/

(function () {
  const TIERS = [
    { min: 25,   max: 300,   price: 19.99 },
    { min: 301,  max: 600,   price: 17.99 },
    { min: 601,  max: 900,   price: 15.99 },
    { min: 901,  max: 1200,  price: 13.99 },
    { min: 1201, max: 1500,  price: 11.99 },
    { min: 1501, max: 100000, price: 9.99 },
  ];
  const BASE_PRICE = TIERS[0].price;

  function getTier(qty) {
    return TIERS.find(t => qty >= t.min && qty <= t.max) || null;
  }

  function fmt(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updateUI(qty) {
    const tier = getTier(qty);
    const rows  = document.querySelectorAll('.mcs-tier-row:not(.mcs-tier-header)');
    const summary    = document.getElementById('mcs-summary');
    const summaryTxt = document.getElementById('mcs-summary-text');
    const minNotice  = document.getElementById('mcs-min-notice');

    // Highlight active row
    rows.forEach(row => {
      const min = parseInt(row.dataset.min);
      const max = parseInt(row.dataset.max);
      row.classList.toggle('mcs-active', !!tier && qty >= min && qty <= max);
    });

    // Below minimum
    if (qty > 0 && qty < 25) {
      minNotice.style.display = 'block';
      summary.style.display   = 'none';
      return;
    }
    minNotice.style.display = 'none';

    // Valid tier
    if (tier) {
      const total   = qty * tier.price;
      const savings = (BASE_PRICE - tier.price) * qty;
      let html = `<strong>${qty.toLocaleString()} units</strong> &times; <strong>${fmt(tier.price)}</strong> = <strong>${fmt(total)}</strong>`;
      if (savings > 0) {
        html += ` &nbsp;·&nbsp; You save <strong>${fmt(savings)}</strong>`;
      }
      summaryTxt.innerHTML = html;
      summary.style.display = 'flex';

      // Override the theme's total price display with the tiered total
      const totalEl = document.querySelector('.price-total-price');
      if (totalEl) totalEl.textContent = fmt(total);

      // Override the unit price display with the tier price
      const priceEl = document.querySelector('.price-item--regular');
      if (priceEl) priceEl.textContent = fmt(tier.price);

    } else {
      summary.style.display = 'none';
    }
  }

  const DISCOUNT_CODES = {
    300:   'BULK300',
    600:   'BULK600',
    900:   'BULK900',
    1200:  'BULK1200',
    1500:  'BULK1500',
    100000:'BULK1501',
  };

  function applyDiscountCode(tier) {
    if (!tier) return;
    const code = DISCOUNT_CODES[tier.max];
    if (!code || tier.price === BASE_PRICE) return;
    sessionStorage.setItem('mcs_discount', code);
    const discInput = document.querySelector('input[name="discount"]');
    if (discInput) discInput.value = code;
    fetch('/discount/' + code, { method: 'GET' }).catch(() => {});
  }

  function init() {
    const numInput   = document.querySelector('.quantity__input');
    const rangeInput = document.getElementById('price-rangeSlider');

    if (!numInput && !rangeInput) return;

    function onNumChange() {
      const qty = parseInt(numInput.value) || 0;
      if (rangeInput) {
        rangeInput.value = Math.min(Math.max(qty, parseInt(rangeInput.min)), parseInt(rangeInput.max));
        rangeInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      updateUI(qty);
      applyDiscountCode(getTier(qty));
    }

    function onRangeChange() {
      const qty = parseInt(rangeInput.value) || 0;
      if (numInput) numInput.value = qty;
      updateUI(qty);
      applyDiscountCode(getTier(qty));
    }

    if (numInput) {
      numInput.addEventListener('change', onNumChange);
      numInput.addEventListener('input',  onNumChange);
    }

    if (rangeInput) {
      rangeInput.addEventListener('change', onRangeChange);
      rangeInput.addEventListener('input',  onRangeChange);
    }

    const initQty = parseInt((rangeInput || numInput).value) || 25;
    updateUI(initQty);
    applyDiscountCode(getTier(initQty));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();